import { ErrorBoundary } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';
import { RouterProvider } from 'react-router';
import { ExceptionUnknownError } from './components/biz/exception';
import { AppCoreProvider } from './providers/core-provider';
import { AppThemeProvider } from './providers/theme-provider';
import router from './routes';
import { isBrowserSupported } from './utils/browser';

function App() {
  const { t } = useTranslation();

  if (!isBrowserSupported()) {
    return (
      <div className="errorContainer">
        <h1>{t('browser_not_supported_title')}</h1>
        <p>{t('browser_not_supported_desc')}</p>
      </div>
    );
  }

  return (
    <ErrorBoundary FallbackComponent={ExceptionUnknownError}>
      <AppThemeProvider>
        <AppCoreProvider>
          <RouterProvider router={router} />
        </AppCoreProvider>
      </AppThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
